import { render } from "./TransferSensorData.vue?vue&type=template&id=42ef6b3c&scoped=true"
import script from "./TransferSensorData.vue?vue&type=script&lang=js"
export * from "./TransferSensorData.vue?vue&type=script&lang=js"

import "./TransferSensorData.vue?vue&type=style&index=0&id=42ef6b3c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42ef6b3c"]])

export default __exports__